import Component from './ColumnChooser.component';

export default Component;
